module.exports = __webpack_public_path__ + "static/media/jessica_lemos.0fd7ca36.jpg";